import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function initVehicleModel() {
  return request({
    url: URL.mdm.basicData.initVehicleModel,
    method: 'post'
  })
}

export function listVehicleModel(data) {
  return request({
    url: URL.mdm.basicData.listVehicleModel,
    method: 'post',
    data
  })
}

export function addVehicleModel(data) {
  return request({
    url: URL.mdm.basicData.addVehicleModel,
    method: 'post',
    data
  })
}

export function updateVehicleModel(data) {
  return request({
    url: URL.mdm.basicData.updateVehicleModel,
    method: 'post',
    data
  })
}

export function deleteVehicleModel(data) {
  return request({
    url: URL.mdm.basicData.deleteVehicleModel,
    method: 'post',
    data
  })
}
